<template>
    <occupants-find
        :params="{
            occupant: $route.params.occupant
        }"
        v-slot="{
            has_loaded,
            is_loading,
            data: occupant,
            error: find_error,
            find
        }"
        @success="onOccupantsFindSuccess"
    >
        <div :class="!has_loaded || find_error ? '' : 'rounded bg-white shadow'">
            <template v-if="!has_loaded">
                <base-loading
                    :retry="find"
                    :error="find_error"
                    class="py-6"
                />

                <error-modal
                    v-if="find_error && $error.is(find_error, { exclude: [400, 422] })"
                    :error="find_error"
                />
            </template>

            <template v-else>
                <occupants-update
                    :params="{
                        occupant: $route.params.occupant
                    }"
                    v-slot="{
                        sid,
                        is_loading: is_saving,
                        error: update_error,
                        update
                    }"
                    @success="onOccupantsUpdateSuccess"
                >
                    <base-form @submit="update(form)">
                        <header class="flex items-center px-4 py-3 border-b sm:px-6 md:py-4">
                            <h1 class="text-lg font-normal">
                                Edit {{ occupant.name }}
                            </h1>
                        </header>

                        <div class="px-4 py-3 border-b sm:px-6 md:py-6">
                            <validator-alert :sid="sid" />

                            <form-section>
                                <template slot="title">Basics</template>
                                <template slot="description">
                                    This is some text.
                                </template>

                                <grid-layout>
                                    <grid-layout-item class="md:w-1/2">
                                        <form-item
                                            :sid="sid"
                                            :is-required="true"
                                            name="name"
                                        >
                                            <template slot="label">Name</template>

                                            <input-text
                                                v-model="form.name"
                                                :sid="sid"
                                                :disabled="is_saving"
                                                name="name"
                                            />
                                        </form-item>
                                    </grid-layout-item>

                                    <grid-layout-item class="md:w-1/2">
                                        <form-item
                                            :sid="sid"
                                            name="email"
                                        >
                                            <template slot="label">Email</template>

                                            <input-text
                                                v-model="form.email"
                                                :sid="sid"
                                                :disabled="is_saving"
                                                type="email"
                                                name="email"
                                            />
                                        </form-item>
                                    </grid-layout-item>

                                    <grid-layout-item class="md:w-1/2">
                                        <form-item
                                            :sid="sid"
                                            name="telephone"
                                        >
                                            <template slot="label">Mobile No.</template>

                                            <input-telephone
                                                v-model="form.telephone"
                                                :sid="sid"
                                                :disabled="is_saving"
                                                type="tel"
                                                name="telephone"
                                            />
                                        </form-item>
                                    </grid-layout-item>
                                </grid-layout>
                            </form-section>
                        </div>

                        <base-form-footer
                            class="rounded-b"
                        >
                            <base-button
                                :is-loading="is_saving"
                                class="w-full btn-blue md:w-auto"
                            >
                                Update Tenant
                            </base-button>
                        </base-form-footer>

                        <error-modal
                            v-if="update_error && $error.is(update_error, { exclude: [422] })"
                            :error="update_error"
                        />

                        <modal-success :is-open="show_updated_modal">
                            <template slot="heading">Tenant updated!</template>

                            <p>This tenant has been updated.</p>

                            <div
                                slot="footer"
                                class="flex flex-col md:flex-row-reverse"
                            >
                                <router-link
                                    :to="{
                                        name: $router.fix('dashboard.*.occupants.show'),
                                        params: {
                                            occupant: occupant.uuid
                                        }
                                    }"
                                    class="text-center btn btn-green"
                                >
                                    Go to Tenant
                                </router-link>
                            </div>
                        </modal-success>
                    </base-form>
                </occupants-update>
            </template>
        </div>
    </occupants-find>
</template>

<script>
    import _ from 'lodash'
    import OccupantsFind from '../../../../components/occupants-find'
    import OccupantsUpdate from '../../../../components/occupants-update'

    export default {
        components: {
            OccupantsFind,
            OccupantsUpdate
        },
        data () {
            return {
                show_updated_modal: false,
                form: {
                    name: null,
                    email: null,
                    telephone: null
                }
            }
        },
        methods: {
            onOccupantsFindSuccess ({ data: occupant }) {
                this.form.name = occupant.name
                this.form.email = occupant.email
                this.form.telephone = occupant.telephone_number
                    ? _.pick(occupant.telephone_number, ['prefix', 'suffix'])
                    : null
            },
            onOccupantsUpdateSuccess () {
                setTimeout(() => {
                    this.show_updated_modal = true
                }, 0)
            }
        }
    }
</script>
